export const PATIENT_INFORMATION_ENDPOINTS = {
    GET_PATIENT_INFORMATION: '/patients/patientInformation',
    POST_PATIENT_INFORMATION: '/patients/patientInformation',
    GET_PATIENT_ENTITLEMENTS: '/patients/entitlements',
} as const;